<template>
  <div class="default-column-box"
       :class="{'datetime': ruleType === 'datetime'}">
    <span v-if="ruleKey !== 'result'">
      {{parseValue | translate}}
    </span>
    <template v-else>
      <div v-for="(value, index) in customSplit((this.ruleValue || '-'))"
           :key="index">
        {{value}}
      </div>
    </template>
  </div>
</template>

<script>
import { chunk, map } from 'lodash';
import rulesProps from '../mixins';
import { momentFormat } from '../filters';

export default {
  name: 'DefaultColumnBox',
  mixins: [rulesProps],
  computed: {
    parseValue() {
      let value = '-';
      if ((this.ruleType === 'datetime' || this.ruleKey === 'match_datetime') && this.ruleValue) {
        value = momentFormat((this.ruleValue * 1000),
          `${this.$store.state.dateFormat} HH:mm:ss`,
          this.$store.state.timezone);
      } else if (this.ruleValue || this.ruleValue === 0) {
        switch (this.ruleKey) {
          case 'stake':
          case 'odd':
          case 'winnings':
          case 'special_value':
            value = (+this.ruleValue).toFixed(2);
            break;
          default:
            value = this.ruleValue;
            break;
        }
      }
      return value;
    },
  },
  methods: {
    customSplit(str) {
      return map(chunk(str.split(', '), 10), item => item.join(', '));
    },
  },
};
</script>

<style lang="scss" scoped>
  .default-column-box {
    display: inline-table;
  }
 .datetime {
   width: 140px;
 }
</style>
